import { Chart, registerables } from 'chart.js';
import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { IMenu } from '../models/imenu.model';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CompanyInfoViewModel, CurrentUserModel } from '../models/account-ledger.model';
import { MyAccountService } from '../services/myAccount.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { GetDebtorHistory } from '../models/Profile-view.model';
import { ShoppingCartService } from '../services/shopping-cart.service';
import { CommonService } from '../services';
// tslint:disable-next-line:import-blacklist
import { Subscription, Subject } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ApiResponse } from '../models/api-response.model';
import { filter, takeUntil } from 'rxjs/operators';
import { NgProgressService } from '../services/ngProgress.service';
import { ExternalScriptService } from '../services/external-script.service';


declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit, OnDestroy {
  title = 'Account';
  companyInfo: CompanyInfoViewModel;
  transactionalHistoryData: any;
  transactionalHistoryChart: any;
  accountId: string;
  narrowMode = false; // check if the narrow sidebar should be displayed

  summaryLoadingStatus = true;
  chartLoadingStatus = true;
  hasAdminAccess = false;
  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  // charts
  [x: string]: any;
  transantionSummaryChart: any;
  getDebtorHistory: Array<GetDebtorHistory>;
  currentUserModel: CurrentUserModel;
  isAuthenticated: boolean;
  // Company Information menus
  companyInfoMenu: IMenu[] = [
    {
      menuName: 'Company Information',
      menuIconUrl: '../images/site-icons/my-account/company-info.svg',
      menuRouter: 'compinfo'
    },
    {
      menuName: 'Delivery Locations',
      menuIconUrl: '../images/site-icons/my-account/delivery-add.svg',
      menuRouter: 'deliverylocations'
    },
    {
      menuName: 'End-User Information',
      menuIconUrl: '../images/site-icons/my-account/end-user-info.svg',
      menuRouter: 'enduseraddress'
    },
  ];
  companyInfoMenu2: IMenu[] = [
    {
      menuName: 'Company Information',
      menuIconUrl: '../images/site-icons/my-account/company-info.svg',
      menuRouter: 'compinfo'
    }
  ];
  // Finance menus
  financeMenu: IMenu[] = [];

  financeMenu2: IMenu[] = [
    {
      menuName: 'Account Ledger',
      menuIconUrl: '../images/site-icons/my-account/account-ledger.svg',
      menuRouter: 'accountledger'
    }
  ];
  // Portal Access
  portalMenu: IMenu[] = [
    {
      menuName: 'Add New User',
      menuIconUrl: '../images/site-icons/my-account/add-new-user.svg',
      menuRouter: 'users/addusers'
    },
    {
      menuName: 'Manage Existing Users',
      menuIconUrl: '../images/site-icons/my-account/existing-user.svg',
      menuRouter: 'users'
    }
  ];
  // Integration
  integrationNMenu: IMenu[] = [];
  // Orders
  orderMenu: IMenu[] = [
    {
      menuName: 'Open Orders',
      menuIconUrl: '../images/site-icons/my-account/myorder.svg',
      menuRouter: 'openorders'
    },
    {
      menuName: 'Recently Invoiced Orders',
      menuIconUrl: '../images/site-icons/my-account/myorder.svg',
      menuRouter: 'shippedorders'
    },
    {
      menuName: 'Returns',
      menuIconUrl: '../images/site-icons/my-account/return.svg',
      menuRouter: 'returns'
    }
  ];

  orderMenu2: IMenu[] = [
    {
      menuName: 'Recently Invoiced Orders',
      menuIconUrl: '../images/site-icons/my-account/myorder.svg',
      menuRouter: 'shippedorders'
    }
  ];

  showApiBox = false;
  watchUrlchange$: Subscription;
  watchDashboardChange$: Subscription;

  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
  @ViewChild(BreadcrumbComponent, {static: false}) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb
  @ViewChild('chartTransactionSummary', {static: false}) chartTransactionSummary: ElementRef;

  constructor(
    private myAccountService: MyAccountService,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private externalScriptService: ExternalScriptService,
    private router: Router,
    public authService: AuthService,
    public ngProgress: NgProgressService
  ) {
    commonService.emitUpdateSideBarActiveItem('account');
    Chart.register(...registerables);
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
  
  ngOnInit() {
    this.summaryLoadingStatus = true;
    this.chartLoadingStatus = true;
    this.showApiBox = false;

    this.externalScriptService
      .loadScript('https://api.payway.com.au/rest/v1/payway.js')
      .then(() => {
        this.externalScriptService.runMyScript();
      })
      .catch((error) => console.error(error));

    this.authService.getLoginInfo()
      .subscribe((res: CurrentUserModel) => {
        this.currentUserModel = res;

        this.financeMenu = [
          {
            menuName: 'Account Ledger',
            menuIconUrl: '../images/site-icons/my-account/account-ledger.svg',
            menuRouter: 'accountledger'
          },
          {
            menuName: 'Digital Wallet',
            menuIconUrl: '../images/site-icons/my-account/digital-wallet.svg',
            menuRouter: 'digitalwallet'
          }
        ];

        if (this.currentUserModel?.hasAdminAccess || this.currentUserModel?.hasPurchaseAccess) {
          this.financeMenu.push(
            {
              menuName: 'Make a Payment',
              menuIconUrl: '../images/site-icons/my-account/payment.svg',
              menuRouter: 'payment'
            }
          )
        }

        this.isAuthenticated = true;
        this.authService.monitorLoginInfoChange(this.currentUserModel);
        if (this.currentUserModel != null && this.currentUserModel.hasAdminAccess === true) {
          this.hasAdminAccess = true;
        }
        if (this.hasAdminAccess) {
          this.integrationNMenu = [
            {
              menuName: 'API Documentation',
              menuIconUrl: '../images/site-icons/my-account/api-doc.svg',
              menuRouter: '/kb/doc/apidocumentation'
            }
          ];
        }

        this.myAccountService.GetAPIIntegrationStatus().subscribe((response: ApiResponse) => {
          if (response && response.status) {
            this.showApiBox = response.status;
          }
          if (
            res.isStaffAccount
            // || this.showApiBox
          ) {
            let brandingMenu: IMenu =
            {
              menuName: 'Branding',
              menuIconUrl: '../images/site-icons/my-account/company-info.svg',
              menuRouter: 'branding'
            }
            const apiTokenMenu: IMenu = {
              menuName: 'API Tokens',
              menuIconUrl: '../images/site-icons/my-account/api-token.svg',
              menuRouter: 'APITokens'
            };
            this.integrationNMenu.splice(0, 0, brandingMenu);
            this.integrationNMenu.push(apiTokenMenu);
          }
          if (this.commonService.getIsDevOps()) {
            const apiV2CCMenu: IMenu = {
              menuName: 'B2B V2 API Client Credentials',
              menuIconUrl: '../images/site-icons/my-account/api-token.svg',
              menuRouter: 'APICredentialsV2'
            }
            this.integrationNMenu.push(apiV2CCMenu);
          }
        },
        (error: any) => {
          console.error(error);
          this.handleError(error);
        });
      },
        (error: any) => {
          console.error(error);
          this.handleError(error);
        });

      this.watchUrlchange$ = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(res => {
        this.breadcrumbRef.ngAfterViewInit();

        const currentURL = this.router.url;

        if (currentURL === '/myAccount') {
          this.refreshDebtorHistoryChart();
        }
      });

      this.watchDashboardChange$ = this.shoppingCartService.dashboardChanged.subscribe(aliasLogin => {
        this.refreshDebtorHistoryChart();
      });


      this.myAccountService.getCompanyProfile().pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: CompanyInfoViewModel) => {
          this.myAccountService.companyProfile$.next(data);
          this.companyInfo = data;
          this.summaryLoadingStatus = false;

        },
          (error: any) => {
            console.error(error);
          });

      // IF an user refresh the web browser
      if (this.router.url !== '/myAccount') {
        this.narrowMode = true;
      }

      this.router.events
        .subscribe((event) => {
          if (event instanceof NavigationEnd) {
            if (event.url === '/myAccount') {
              this.narrowMode = false;
              $('.page-contents').animate({ scrollLeft: 0 }, 400);
            }
          }
        });
    }

  ngOnDestroy(): void {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

    if (this.watchUrlchange$) {
      this.watchUrlchange$.unsubscribe();
    }
    if (this.watchDashboardChange$) {
      this.watchDashboardChange$.unsubscribe();
    }
  }

  changeMode(event): void {
    event.preventDefault();
    event.stopPropagation();

    this.narrowMode = true;
  }

  refreshDebtorHistoryChart() {
    this.accountId = this.commonService.readCookie('AccountId');
    this.getDebtorHistory = new Array<GetDebtorHistory>();
    this.myAccountService.getDebtorHistory(this.accountId).subscribe((result: Array<GetDebtorHistory>) => {
      this.getDebtorHistory = result;
      this.chartLoadingStatus = false;
      if (this.getDebtorHistory.length) this.initializeTransactionSummaryChart(this.chartTransactionSummary);
    });
  }

  initializeTransactionSummaryChart(chart: ElementRef) {
    if(chart == undefined) {
      return;
    }
    const ctx = chart.nativeElement;
    const currentMonth = new Date().getMonth();
    const currentYear = this.getDebtorHistory[0];
    const previousYear = this.getDebtorHistory[1];
    const lastPreviousYear = this.getDebtorHistory[2];
    this.transactionalHistoryData = [];
    this.transactionalHistoryData.push({
      label: currentYear.out_period,
      // data: [currentYear.out_01_jan, currentYear.out_02_feb, currentYear.out_03_mar, currentYear.out_04_apr, currentYear.out_05_may, currentYear.out_06_jun, currentYear.out_07_jul, currentYear.out_08_aug, currentYear.out_09_sep, currentYear.out_10_oct, currentYear.out_11_nov, currentYear.out_12_dec],
      data: [currentMonth >= 1 ? currentYear.out_01_jan : null,
      currentMonth >= 2 ? currentYear.out_02_feb : null,
      currentMonth >= 3 ? currentYear.out_03_mar : null,
      currentMonth >= 4 ? currentYear.out_04_apr : null,
      currentMonth >= 5 ? currentYear.out_05_may : null,
      currentMonth >= 6 ? currentYear.out_06_jun : null,
      currentMonth >= 7 ? currentYear.out_07_jul : null,
      currentMonth >= 8 ? currentYear.out_08_aug : null,
      currentMonth >= 9 ? currentYear.out_09_sep : null,
      currentMonth >= 10 ? currentYear.out_10_oct : null,
      currentMonth >= 11 ? currentYear.out_11_nov : null,
      currentMonth >= 12 ? currentYear.out_12_dec : null],
      borderColor: '#C20047',
      backgroundColor: '#C20047',
      fill: false
    });

    this.transactionalHistoryData.push({
      label: previousYear.out_period,
      data: [previousYear.out_01_jan, previousYear.out_02_feb, previousYear.out_03_mar, previousYear.out_04_apr, previousYear.out_05_may, previousYear.out_06_jun, previousYear.out_07_jul, previousYear.out_08_aug, previousYear.out_09_sep, previousYear.out_10_oct, previousYear.out_11_nov, previousYear.out_12_dec],
      borderColor: '#FFD1D1',
      backgroundColor: '#FFD1D1',
      fill: false
    });


    this.transactionalHistoryData.push({
      label: lastPreviousYear.out_period,
      data: [lastPreviousYear.out_01_jan, lastPreviousYear.out_02_feb, lastPreviousYear.out_03_mar, lastPreviousYear.out_04_apr, lastPreviousYear.out_05_may, lastPreviousYear.out_06_jun, lastPreviousYear.out_07_jul, lastPreviousYear.out_08_aug, lastPreviousYear.out_09_sep, lastPreviousYear.out_10_oct, lastPreviousYear.out_11_nov, lastPreviousYear.out_12_dec],
      borderColor: '#666666',
      backgroundColor: '#666666',
      fill: false
    });



    this.transactionalHistoryChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        datasets: this.transactionalHistoryData
      },
      options: {
        responsive: true,
        elements:{
          line: {
            tension: 0.3
          }
        },
        plugins: {
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (tooltipItem) {
                return tooltipItem.formattedValue.toLocaleString();
              }
            }
          },
          legend: {
            display: true,
            position: 'top',
            labels: {
              padding: 30
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        scales: {
          xAxes: {
            display: true,
            grid: {
              display: false
            },
            ticks: {
              padding: 7,
              font: {
                size: 6
              }
            }
          },
          yAxes: {
            display: true,
            grid: {
              borderDash:[3,3]
            },
            ticks: {
              callback: function (label, index, labels) {
                return label.toLocaleString();
              },
              padding: 5,
              maxTicksLimit: 15,
              font: {
                size: 6
              }
            },
            // maintainAspectRatio: false
          },
        }
      }
    });

  }

  public hasCustomersMenu(): boolean {
    return this.authService.MENU_SECTION_1.findIndex(i => i.menuId === 'customers') > 0;
  }

  close() {
    if (this.narrowMode) {
      this.router.navigateByUrl('/myAccount');
    } else {
      this.router.navigateByUrl('/home');
    }
  }

}
